export default __webpack_public_path__ + "static/feature-banner-yolo-0f420b36daed590c085061989768fc1d.jpg";